import { Header1 } from '@cian/ui-kit';

import { FC } from 'react';

import { ITitleProps } from './types';

export const Title: FC<ITitleProps> = props => {
  const { coworkingName, className } = props;

  return (
    <div className={className}>
      <Header1>{coworkingName}</Header1>
    </div>
  );
};

Title.displayName = 'Title';
